module.exports = __webpack_public_path__ + "static/media/feelingProudAlt.35445ff9.gif";